import React from "react";
import { Link } from "react-router-dom";

function GallerySection() {
  return (
    <section className="gallery-section overlay text-white pt-115 rpt-95 rpb-80">
      <div className="container-fluid clearfix">
        <div className="section-title text-center mb-55">
          <span className="sub-title">Our Gallery</span>
          <h2>Awards, Achievements and Recognition</h2>
        </div>
        <div className="row small-gap">
          <div className="col-lg-3 col-sm-6">
            <div className="gallery-item wow fadeInUp delay-0-2s">
              <img
                src={
                  require(`../../assets/images/gallery/gallery-1.jpg`)
                }
                alt="Gallery"
              />
              <div className="gallery-content">
                <span className="category">
                  <Link to="/services">Awarded by Sonali Bendre</Link>
                </span>
                <h5>
                  <Link to="/services">Best Emerging Company of the Year 2024, Awarded by Sonali Bendre</Link>
                </h5>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="gallery-item wow fadeInUp delay-0-4s">
              <img
                src={
                  require(`../../assets/images/gallery/gallery-2.jpg`)
                }
                alt="Gallery"
              />
              <div className="gallery-content">
                <span className="category">
                  <Link to="/services">World Trade Center Mumbai</Link>
                </span>
                <h5>
                 <Link to="/services">Advice for Business Growth: How Next Cosmos Technology Can Help Accelerate Your Business</Link>
                </h5>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="gallery-item wow fadeInUp delay-0-6s">
              <img
                src={
                  require(`../../assets/images/gallery/gallery-3.jpg`)
                }
                alt="Gallery"
              />
              <div className="gallery-content">
                <span className="category">
                  <Link to="/services">World Trade Center Mumbai</Link>
                </span>
                <h5>
                  <Link to="/services">Awarded by Sonali Bendre</Link>
                </h5>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="gallery-item wow fadeInUp delay-0-8s">
              <img
                src={
                  require(`../../assets/images/gallery/gallery-4.jpg`)
                }
                alt="Gallery"
              />
              <div className="gallery-content">
                <span className="category">
                  <Link to="/services">World Trade Center Mumbai</Link>
                </span>
                <h5>
                  <Link to="/services">An Overview of Next Cosmos Technology Services in Mumbai</Link>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GallerySection;
